export enum FeatureFlag {
	EnablePLGTestPage = 'enable_plg_test_page',
}
